import React from "react";
import {
  Grid,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  IconButton,
  Dialog,
} from "@mui/material";
import "react-quill/dist/quill.snow.css";
import CloseIcon from "@mui/icons-material/Close";
import CustomTypography from "../../globalStyles/fonts";

const ShippingServiceMapDetailsModal = ({ shippingService, open, onClose }) => {
  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <DialogTitle>{"Port Details"}</DialogTitle>
          <IconButton>
            <CloseIcon onClick={onClose} />
          </IconButton>
        </div>
        <Divider style={{ marginBottom: "10px" }} />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <CustomTypography
                color={"var(--text-heading)"}
                fontSize={14}
                fontWeight={400}
              >
                Service
              </CustomTypography>
              <TextField
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={shippingService?.service || ""}
                InputProps={{
                  readOnly: true,
                  style: {
                    color: "var(--text-primary)",
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography
                color={"var(--text-heading)"}
                fontSize={14}
                fontWeight={400}
              >
                Provider
              </CustomTypography>
              <TextField
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={shippingService?.provider || ""}
                InputProps={{
                  readOnly: true,
                  style: {
                    color: "var(--text-primary)",
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography
                color={"var(--text-heading)"}
                fontSize={14}
                fontWeight={400}
              >
                Shipping Service
              </CustomTypography>
              <TextField
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={shippingService?.shipping_service?.service || ""}
                InputProps={{
                  readOnly: true,
                  style: {
                    color: "var(--text-primary)",
                    backgroundColor: "var(--bg-input)",
                  },
                }}
              />
            </Grid>
            {!localStorage.getItem("client_id") && (
              <Grid item xs={12} sm={6}>
                <CustomTypography
                  color={"var(--text-heading)"}
                  fontSize={14}
                  fontWeight={400}
                >
                  Client
                </CustomTypography>
                <TextField
                  size="small"
                  autoFocus
                  margin="dense"
                  variant="outlined"
                  type="text"
                  fullWidth
                  value={shippingService?.client_id?.name || ""}
                  InputProps={{
                    readOnly: true,
                    style: {
                      color: "var(--text-primary)",
                      backgroundColor: "var(--bg-input)",
                    },
                  }}
                />
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions style={{ padding: 10 }}>
          <Button
            onClick={onClose}
            variant="outlined"
            style={{ textTransform: "none" }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default ShippingServiceMapDetailsModal;
